"use client";

import { Card, CardContent } from "@/components/ui/card";
import { Shield, Lock, Eye, FileCheck, TriangleAlert } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function DetailsduService() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const items = [{
    icon: Shield,
    title: "Architecture Security-by-Design",
    description: "Intégrer les principes de cybersécurité dès les premières phases de conception pour assurer une infrastructure robuste et résiliente."
  }, {
    icon: Lock,
    title: "Conformité et Alignement Réglementaire",
    description: "Naviguer avec confiance et clarté stratégique dans des paysages réglementaires complexes (RGPD, NIS2, DORA)."
  }, {
    icon: Eye,
    title: "Détection et Réponse aux Menaces",
    description: "Mettre en œuvre des capacités avancées de surveillance, de détection d'anomalies et de réponse aux incidents pour une défense proactive."
  }, {
    icon: FileCheck,
    title: "Souveraineté Numérique et Confiance",
    description: "Établir des stratégies de cloud souverain et des cadres de gouvernance des données qui renforcent le contrôle organisationnel."
  }, {
    icon: TriangleAlert,
    title: "Gestion des Risques et Résilience",
    description: "Construire des programmes de résilience adaptative qui anticipent les menaces, minimisent l'impact et accélèrent la reprise."
  }];
  return <section className="relative bg-background py-24 overflow-hidden">
      {}
      <div className="absolute inset-0 opacity-5 bg-cover bg-center" style={{
      backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1520072/img/constellation_texture_cyber.png)",
      backgroundAttachment: "scroll",
      transform: "translateY(0)",
      transition: "transform 1.2s ease-out"
    }} />

      <div className="container mx-auto px-6 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          {}
          <div ref={leftRef} className={`transition-all duration-500 ease-out ${leftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            <Card className="glass-effect border border-muted/30 shadow-medium">
              <CardContent className="p-8 space-y-6">
                <h2 className="text-4xl font-display font-bold text-foreground leading-tight">
                  Cybersécurité et Confiance Numérique
                </h2>
                <div className="space-y-4 text-muted-foreground leading-relaxed">
                  <p>
                    À l'ère de l'escalade des cybermenaces et des exigences réglementaires strictes, la cybersécurité n'est plus une réflexion technique secondaire — c'est un impératif stratégique.
                  </p>
                  <p>
                    NorthStar Advisory s'associe à la direction exécutive pour construire des stratégies de sécurité complètes qui protègent les actifs critiques, assurent la conformité réglementaire et favorisent la confiance numérique à travers l'entreprise.
                  </p>
                  <p>
                    Notre approche intègre la maîtrise technique et la clarté stratégique, offrant des architectures de sécurité résilientes qui permettent une croissance durable et un avantage concurrentiel.
                  </p>
                </div>
              </CardContent>
            </Card>
          </div>

          {}
          <div ref={rightRef} className={`transition-all duration-500 ease-out ${rightVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            <Card className="glass-effect border border-primary/20 shadow-strong backdrop-blur-md">
              <CardContent className="p-8 space-y-6">
                {items.map((item, i) => {
                const Icon = item.icon;
                return <div key={i} data-index={i} className={`flex gap-4 items-start transition-all duration-500 ease-out ${rightVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
                  transitionDelay: rightVisible ? `${i * 50}ms` : "0ms"
                }}>
                      {}
                      <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
                        <Icon className="w-5 h-5 text-primary" />
                      </div>

                      {}
                      <div className="flex-1">
                        <div className="flex items-baseline gap-2 mb-2">
                          <span className="text-primary font-display font-semibold text-lg">
                            {i + 1}.
                          </span>
                          <h3 className="text-foreground font-semibold text-lg leading-tight">
                            {item.title}
                          </h3>
                        </div>
                        <p className="text-muted-foreground text-sm leading-relaxed">
                          {item.description}
                        </p>
                      </div>
                    </div>;
              })}
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </section>;
}